import React from "react";
import { Node, mergeAttributes } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Chip from "@mui/material/Chip";
import { tastingToken } from "../../utils/postContent";

function TastingNodeView({ node, deleteNode }) {
  const { tastingUuid, title } = node.attrs;
  return (
    <NodeViewWrapper as="div" data-tasting={tastingUuid} className="post-tasting-node">
      <Box
        sx={{
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
          px: 1.5,
          py: 1.25,
          my: 1,
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexWrap: "wrap",
        }}
      >
        <Chip size="small" label="Smagning" variant="outlined" />
        <Typography variant="body2" sx={{ fontWeight: 600, flex: 1 }}>
          {title || "Vinsmagning"}
        </Typography>
        <Typography
          component="button"
          type="button"
          variant="caption"
          onClick={deleteNode}
          sx={{
            border: 0,
            background: "none",
            cursor: "pointer",
            color: "text.secondary",
            p: 0,
          }}
        >
          Fjern
        </Typography>
      </Box>
    </NodeViewWrapper>
  );
}

export const Tasting = Node.create({
  name: "tasting",
  group: "block",
  atom: true,
  draggable: false,
  selectable: true,

  addAttributes() {
    return {
      tastingUuid: { default: null },
      title: { default: "" },
    };
  },

  parseHTML() {
    return [
      {
        tag: "div[data-type='tasting']",
        getAttrs: (el) => ({
          tastingUuid: el.getAttribute("data-tasting-uuid"),
          title: el.getAttribute("data-title") || "",
        }),
      },
    ];
  },

  renderHTML({ node }) {
    const id = node.attrs.tastingUuid;
    return [
      "div",
      mergeAttributes({
        "data-type": "tasting",
        "data-tasting-uuid": id,
        "data-title": node.attrs.title || "",
      }),
      tastingToken(id),
    ];
  },

  addNodeView() {
    return ReactNodeViewRenderer(TastingNodeView);
  },

  addCommands() {
    return {
      insertTasting:
        (attrs) =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: {
              tastingUuid: attrs.tastingUuid,
              title: attrs.title || "",
            },
          }),
    };
  },
});

export default Tasting;
